/**
 * @deprecated This function is deprecated and should not be used in new code as of May 2025
 * Removes the `__typename` property from an object.
 */
export function removeTypeName(object: any) {
  // eslint-disable-next-line
  const { __typename, ...other } = object;
  return other;
}
